import { Injectable } from '@angular/core';
import { Select, Select$ } from '@angular-redux3/store';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, map, share, tap, throttleTime, withLatestFrom } from 'rxjs/operators';

import { startTimer } from '../../store';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {
  @Select$(['player', 'media', 'duration'], obs$ => obs$.pipe(filter(Boolean))) readonly duration$: Observable<number>;
  @Select(['player', 'currentPosition']) private readonly currentPosition$: Observable<number>;
  @Select(['player', 'timestamp']) private readonly lastUpdate$: Observable<number>;
  @Select(['player', 'isPlaying']) private readonly isPlaying$: Observable<boolean>;
  @Select(['player', 'volume']) readonly volume$: Observable<number>;
  progress$: Observable<number> = of(0);
  timer$: Observable<number> = of(0);
  private elapsed = 0;
  private lastDuration = 0;

  constructor(
  ) {
    this.lastUpdate$.subscribe((lastUpdate) => {
      combineLatest([this.duration$, this.currentPosition$]).subscribe(([duration, currentPosition]) => {
        if (this.elapsed - 2 > currentPosition || this.elapsed + 2 < currentPosition || duration !== this.lastDuration) {
          this.lastDuration = duration;
          this.timer$ = startTimer(duration, this.isPlaying$, currentPosition).pipe(
            throttleTime(50),
            share()
          );
          this.progress$ = this.timer$.pipe(
            tap((elapsed) => this.elapsed = elapsed),
            map((elapsed) => +(Number(elapsed / duration * 100).toFixed(3))),
            share()
          );
        }
      });
    });
  }
}
